import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const LAST_LOGIN_REMINDER_NAMESPACE =
  '@mc/authentication/ce-3448-last-login-reminder'

export const i18nInstance = registerI18nResources({
  namespace: LAST_LOGIN_REMINDER_NAMESPACE,
  resources: {
    'en-US': enUS,
  },
})
